export default __webpack_public_path__ + "static/1125-354197fd82fbee2121680dc52c78002c.gif";